<template>
	<div id="churchsInputComponent">
		<div style="position: relative">
			<input type="text" class="form-control form-control-sm" aria-describedby="church" onfocus="this.select()"
				v-model="searchInput" :readonly="!(listChurchs.length > 0)"
				@blur="blur"
				@focus="focusInput=true"
				@keyup="keyupLocal($event)">
			<button @click="clear" v-show="false" ref="clear">Limpiar</button>
			<small id="emailHelp" class="form-text text-muted" @click="getAllChurchsLocal" ref="getChurchs" v-show="searching">
				<i class="spinner-border" style="width: 16px; height: 16px"></i>
				<i>Buscando iglesias . . .</i>
			</small>
			<small id="emailHelp" class="form-text text-muted" v-show="(!searching && listChurchs.length > 0)">
				<i>Escriba y seleccione la iglesia de la lista </i>
				<i class="fas fa-check text-success float-right" v-if="data.id > 0" :title="'Código seleccionado: ' + data.id"></i>
				<i class="fas fa-exclamation-triangle text-warning float-right" v-else title="No ha seleccionado un item de la lista"></i>
			</small>
			<ul class="list-result-input" v-show="listChurchsSearch.length > 0 && searchInput.length > minShow && focusInput">
				<li v-for="(item, index) in listChurchsSearch" :key="index" @click="selectedChurch(item)">
					<div>
						<b>{{item.type_church.name}} {{item.name}}</b> - Distrito: {{item.district.name}}
					</div>
					<small>{{item.entity.name}}</small>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import errors from '@/mixins/errors.js'
	import axiosAction from '@/mixins/axiosAction.js'
	import church from '@/mixins/generals/church.js'
	
	export default {
		name: 'churchsInputComponent',
		mixins: [axiosAction, errors, mixin, church],
        props: ['url'],
		data () {
			return {
				data: {
					id: 0,
					string: '',
					item: {}
				},
				searchInput: '',
				minShow: 3,
				searching: false,
				focusInput: false
			}
		},
		computed: {
			listChurchsSearch() {
                let listChurchs = []
				if(this.searchInput.length > this.minShow) {
					listChurchs = this.listChurchs.filter(c => c.name.toLowerCase().indexOf(this.searchInput.toLowerCase()) > -1)
				}
                return listChurchs
			}
		},
		methods: {
            initComponentLocal() {
			},
			clear() {
				this.searchInput = ''
				this.clearData()
			},
			clearData() {
				this.data.string = ''
				this.data.id = 0
				this.data.item = {}
				this.$emit('actionSelectItem', this.data)
			},
			blur() {
				setTimeout(() => {
					this.focusInput = false
				}, 300)
			},
			getAllChurchsLocal() {
				if(this.listChurchs.length == 0) {
					this.searching = true
					this.getAllChurchs(1, 1)
				}
			},
			getAllChurchsResultLocal(response){ 
				this.searching = false
			},
			keyupLocal(event) {
				if(this.data.id > 0) {
					this.clearData()
				}
			},
			resultAxiosLocal(responseLocal, response) {
				this.$emit('hideLockScreen')
				switch(responseLocal) {
					case 'getAllChurchsResult': this.getAllChurchsResult(response); break;
					default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
				}
			},
			selectedChurch(item) {
                this.data.string = item.type_church.name + ' ' + item.name + ' (' + item.synthetic + ')'
                this.data.id = item.id
				this.data.item = item
				this.searchInput = item.type_church.name + ' ' + item.name + ' (' + item.synthetic + ')'
				this.$emit('actionSelectItem', this.data)
			},
		},
		mounted () {
            this.initComponentLocal()
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.list-result-input {
	margin-top: -19px;
	border: 1px solid #ccc;
	background-color: white;
	position: absolute;
	z-index: 1;
	width: 100%;
	box-shadow: 1px 1px #ccc;
	li {
		padding: 5px 10px;
		border-bottom: 1px solid #ddd;
	}
	li:hover {
		background: #5bc0de;
		color:#fff;
		cursor: pointer;
	}
}
</style>
